import { render } from "./shortcut_key.vue?vue&type=template&id=d4e71bae"
import script from "./shortcut_key.vue?vue&type=script&lang=js"
export * from "./shortcut_key.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__